import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "./index.css";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import landing_imobile_image from "../../assets/images/landing_imobile_image.png";
import { ArrowRightIcon } from "lucide-react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CardMedia,
  Grid,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/system";
import moment from "moment";
import React, { useEffect,  useState } from "react";
import "react-awesome-slider/dist/styles.css";
import { Helmet } from "react-helmet";
import "react-multi-carousel/lib/styles.css";
import { useNavigate } from "react-router-dom";
import { HomeIcon, PointerIcon } from "../../assets/images/FrankIcons";
import iconThree from "../../assets/images/FrankIcons/assuree@4x.png";
import iconOne from "../../assets/images/FrankIcons/ecologique@4x.png";
import iconTwo from "../../assets/images/FrankIcons/economique@4x.png";
import homeSliderThree from "../../assets/images/FrankIcons/homeSliderImagethree.jpg";
import StepScreen1 from "../../assets/images/FrankIcons/Slide_1_.png";
import StepScreen2 from "../../assets/images/FrankIcons/Slide_2_.png";
import StepScreen3 from "../../assets/images/FrankIcons/Slide_3_.png";
import apiServices from "../../services/RequestHandler";
import CustomButton from "../../UiComponent/CustomButton";
import CustomFooter from "../../UiComponent/CustomFooter";
import pPostImage from "../../assets/images/FrankIcons/p_PostImage.png";
import Loader from "../../UiComponent/Loader";
import { Squircle } from "corner-smoothing";

import NewHeader from "../../UiComponent/NewHeader";
import {
  defaultLabelColors,
  spacing,
} from "../../utils/constants";
import {
  currencyFormat,
  handleLocalize,
  throttle,
} from "../../utils/helper";
import {
  getDataFromLocalStorage,
} from "../../utils/LocalStore.util";
import {
  getDeviceToken,
  requestPermission,
} from "../../utils/notificationListner";
import "moment/locale/fr"; // Import French locale
import TabletView from "./TabletView";
import MobileResponsive from "./MobileResponsive";
import CustomMobileFooter from "../../UiComponent/CustomMobileFooter";
import AnnoucementCard from "../../UiComponent/AnnoucementCard";

function LandingPage(props: any) {
  const { classes } = props;
  const theme = useTheme();
  const screen_1024 = useMediaQuery(theme.breakpoints.up(1025));
  const screen_600 = useMediaQuery(theme.breakpoints.up(601));

  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));

  const xl = useMediaQuery(theme.breakpoints.up("xl"));

  const [scrollPercentage, setScrollPercentage] = React.useState(0);
  const slides = [
    // comment by asad iqbal 1/14/2025 on Ben Demand ( Launching Frank C2C ppt)
    // {
    //   imageUrl: homeSlider,
    //   caption: "Vendez ",
    //   captionTwo: "sur la Marketplace",
    // },
    // {
    //   imageUrl: homeSliderTwo,
    //   caption: "Pour les",
    //   captionTwo: "professionnels",
    // },
    //comment by asad iqbal 1/14/2025 on Ben Demand ( Launching Frank C2C ppt)
    {
      imageUrl: homeSliderThree,
      // caption: `Déménagez `,
      // captionTwo: "avec Frank",

      caption: "Livraison collaborative",
      captionTwo: "",
    },
  ];
  moment.locale("fr"); // Set moment to use French

  const [currentSlide, setCurrentSlide] = useState(0);

  const navigate = useNavigate();
  const [state, setState] = React.useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      loadingLoader: false,
      randomProducts: [],
    }
  );

  useEffect(() => {
    handleUpdateLanguage();
    handleGetRecentJobs();
    getRandomProducts();
    // eslint-disable-next-line
  }, []);
  const handleExpanded = (state_name: any) => {
    try {
      setState({ [state_name]: !state?.[state_name] });
    } catch (error) {}
  };
  const getRandomProducts = async () => {
    try {
      const resp = await apiServices.getFromApi(
        "/c2c-product-masters/products-random",
        ""
      );

      setState({
        randomProducts: resp?.data ?? [],
      });
      handleGetAllBlog();
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetAllBlog = async () => {
    try {
      setState({ activity: true });
      let resp = await apiServices.getFromApi(
        `c2c-blogs/web?page=1&limit=6`,
        ""
      );
      if (resp?.status === 200 || resp?.status === 201) {
        setState({ allBlogs: resp?.data, totalPage: resp?.total_pages });
        setState({ activity: false });
      }
    } catch (error) {
      setState({ activity: false });
    }
  };

  const handleUpdateLanguage = async () => {
    try {
      const user = getDataFromLocalStorage("user");
      if (user) {
        await apiServices.postFromApi("/c2c/u-lang", { lang: "fr" }, "");
      }
    } catch (error) {}
  };

  // useEffect(() => {}, [selector?.lang]);

  useEffect(() => {
    const handleScroll = throttle(() => {
      const totalHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const currentScroll = window.scrollY;
      setScrollPercentage((currentScroll / totalHeight) * 100);
    }, 100); // Throttle the scroll event every 100ms

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleGetRecentJobs = async () => {
    try {
      setState({ loadingLoader: true });
      let user = getDataFromLocalStorage("user");

      const body = { type: "All", limit: false, user: user?.id ?? null };
      let resp = await apiServices.postFromApi(
        "c2c-shipments/web-all-announcements",
        body,
        ""
      );
      const slicedData = resp?.data?.slice(0, xl ? 12 : lg ? 8 : md ? 4 : 3);

      setState({
        annoucesData: slicedData,
        loadingLoader: false,
      });
    } catch (error) {}
  };

  useEffect(() => {
    const slicedData = state.annoucesData?.slice(
      0,
      xl ? 12 : lg ? 8 : md ? 4 : 3
    );

    setState({
      annoucesData: slicedData,
      loadingLoader: false,
    });
    // eslint-disable-next-line
  }, [xl, lg, md, sm]);

  const handleNext = () => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  useEffect(() => {
    const slideInterval = setInterval(() => {
      handleNext();
    }, 4000);

    return () => clearInterval(slideInterval);
    // eslint-disable-next-line
  }, [currentSlide]);

  useEffect(() => {
    let user = getDataFromLocalStorage("user");

    if (user) {
      checkForPermission();
    }
  }, []);

  const checkForPermission = async () => {
    try {
      let user = getDataFromLocalStorage("user");
      const isNotifAvailable = "Notification" in window;
      if (isNotifAvailable) {
        const permissionGranted = await requestPermission();
        if (permissionGranted) {
          const token = await getDeviceToken();

          if (token && user?.id) {
            // Only proceed with the API call if a token was successfully retrieved

            await apiServices.postFromApi(
              "c2c/u-token",
              {
                device_token: token,
              },
              ""
            );
            console.log("Token saved successfully.");
          } else if (!token) {
            console.warn("Failed to retrieve device token.");
          }
        } else {
          console.log(
            "Notification permission denied. Please enable notifications in your browser settings to receive updates."
          );
        }
      } else {
        console.log("NOTIFICATION NOT SUPPORTED");
      }
    } catch (error) {
      console.error(
        "An error occurred while checking notification permission:",
        error
      );
    }
  };

 

  return (
    <>
      <div
        className="homepage"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          height: "5px",
          width: `${scrollPercentage}%`,
          background: "#ee6931",
          zIndex: 111111111,
          transition: "width 0.2s ease",
          borderRadius: "5px",
          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
        }}
      />
      <Helmet>
        <title>Frank : Service de livraison collaborative</title>
        <link rel="canonical" href="https://www.frank.fr" />
        <meta
          name="description"
          content="Envoyez vos colis à peu de frais ou gagnez de l’argent en transportant ceux des autres grâce à notre plateforme de livraison collaborative . H1 Envoyez vos colis grâce à vos voisins !"
        />
          <link
          rel="icon"
          type="image/png"
          href="../../../public/frank_favicon.png"
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Frank",
            contactPoint: {
              "@type": "ContactPoint",
              telephone: "+33-1-2345-6789",
              contactType: "Customer Service",
              areaServed: "FR",
              availableLanguage: "French",
            },
          })}
        </script>
      </Helmet>
      {screen_1024 ? (
        <div className="web-screen">
          <div
            style={{
              justifyItems: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                maxWidth: 1508,
                width: "100%",
              }}
            >
              <NewHeader />

              <Loader loading={state?.loadingLoader} />

              <div
                style={{
                  padding: 60,
                  background: defaultLabelColors.main_background,
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    position: "relative",
                  }}
                >
                  <Squircle
                    cornerRadius={48}
                    cornerSmoothing={0.6}
                    preserveSmoothing={true}
                    style={{
                      position: "relative",
                      zIndex: 2,
                      marginTop: 80,
                      width: "100%",
                      backgroundColor: "#EE6931",
                      borderRadius: 48,
                    }}
                  >
                    <div
                      style={{
                        padding: "56px 48px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          rowGap: 32,
                        }}
                      >
                        <div>
                          <h1
                            className="envoyez-vos-colis"
                            style={{
                              color: defaultLabelColors.white,
                              fontSize: xl
                                ? "64px"
                                : lg
                                ? "44px"
                                : md
                                ? "40px"
                                : sm
                                ? "28px"
                                : "32px",
                              margin: 0,
                            }}
                          >
                            Envoyez vos colis
                            <br />
                            entre particuliers
                          </h1>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            rowGap: 20,
                            maxWidth: 782,
                            width: "100%",
                            zIndex: 9999,
                          }}
                        >
                          <Squircle
                            cornerRadius={32}
                            cornerSmoothing={0.6}
                            preserveSmoothing
                            className={classes?.banner_section_div}
                            style={{
                              background: defaultLabelColors.white,
                              padding: xl ? 32 : lg ? 26 : md ? 16 : 12,
                              cursor: "pointer",
                              width: "100%",
                              zIndex: 99999,
                            }}
                            onClick={() => {
                              navigate("/send-package");
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <div
                                style={{ flex: 1, cursor: "pointer" }}
                                onClick={() => {
                                  navigate("/send-package");
                                }}
                              >
                                <h3
                                  style={{
                                    margin: 0,
                                    fontFamily: "montserrat-Bold",
                                    fontSize: xl
                                      ? "32px"
                                      : lg
                                      ? "24px"
                                      : md
                                      ? "18px"
                                      : sm
                                      ? "16px"
                                      : "8px",
                                    color: defaultLabelColors.main_font,
                                  }}
                                >
                                  Envoyer un colis
                                </h3>
                                <p
                                  style={{
                                    fontSize: 16,
                                    color: defaultLabelColors.main_font_grey,
                                    fontFamily: "montserrat-Regular",
                                    marginBottom: 0,
                                  }}
                                >
                                  Nos transporteurs prennent en charge vos colis
                                  <br /> pour un envoi économique.
                                </p>
                              </div>
                              <div
                                style={{
                                  background: "#FCE6DD",
                                  padding: 12,
                                  borderRadius: 100,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <ArrowRightIcon color="#EF6A31" />
                              </div>
                            </div>
                          </Squircle>
                          {/* <SmoothCorners
                            corners="60%"
                            // width="100%"
                            onClick={() => {
                              navigate("/send-package");
                            }}
                          
                            borderRadius={`32px !important`}
                          >
                           
                          </SmoothCorners> */}

                          <Squircle
                            cornerRadius={32}
                            cornerSmoothing={0.6}
                            preserveSmoothing
                            className={classes?.banner_section_div}
                            style={{
                              background: defaultLabelColors.white,
                              padding: xl ? 32 : lg ? 26 : md ? 16 : 12,
                              cursor: "pointer",

                              borderRadius: 32,

                              width: "100%",
                            }}
                            onClick={() => {
                              navigate("/transporter-un-colis");
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <div style={{ flex: 1 }}>
                                <h3
                                  style={{
                                    margin: 0,
                                    fontFamily: "montserrat-Bold",
                                    fontSize: xl
                                      ? "32px"
                                      : lg
                                      ? "24px"
                                      : md
                                      ? "18px"
                                      : sm
                                      ? "16px"
                                      : "8px",
                                    color: defaultLabelColors.main_font,
                                  }}
                                >
                                  Transporter un colis
                                </h3>
                                <p
                                  style={{
                                    fontSize: 16,
                                    color: defaultLabelColors.main_font_grey,
                                    fontFamily: "montserrat-Regular",
                                    marginBottom: 0,
                                  }}
                                >
                                  Devenez transporteur et gagnez de l'argent{" "}
                                  <br /> en assurant des livraisons sur vos
                                  trajets.
                                </p>
                              </div>
                              <div
                                style={{
                                  background: "#FCE6DD",
                                  padding: 12,
                                  borderRadius: 100,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <ArrowRightIcon color="#EF6A31" />
                              </div>
                            </div>
                          </Squircle>

                          <p
                            style={{
                              textAlign: "center",
                              color: defaultLabelColors.white,
                              fontFamily: "montserrat-Bold",
                              fontSize: 18,
                              margin: 0,
                              marginTop: 12,
                            }}
                          >
                            Je déménage{" "}
                            <span
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                navigate("/transporter-un-colis");
                              }}
                            >
                              C’est par ici !
                            </span>
                          </p>
                        </div>
                      </div>

                      <div
                        style={{
                          position: "absolute",
                          bottom: -20,
                          left: -30,
                        }}
                      >
                        <svg
                          width="879"
                          height="302"
                          viewBox="0 0 879 302"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M368.64 122.285C532.214 170.906 745.469 130.179 836.269 255.808C930.894 386.727 853.978 545.627 737.8 633.045C641.541 705.474 476.877 639.66 334.184 633.597C206.266 628.163 73.6554 674.377 -32.6185 600.313C-148.409 519.617 -182.063 390.422 -175.946 278.079C-169.733 163.968 -126.278 43.167 -0.320768 7.13355C116.407 -26.2596 238.787 83.686 368.64 122.285Z"
                            fill="url(#paint0_linear_1_5603)"
                            fillOpacity="0.2"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_1_5603"
                              x1="444.303"
                              y1="74.9675"
                              x2="210.836"
                              y2="698.705"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#F9E7E0" />
                              <stop
                                offset="1"
                                stopColor="white"
                                stopOpacity="0"
                              />
                            </linearGradient>
                          </defs>
                        </svg>
                      </div>
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                        }}
                      >
                        <svg
                          width="714"
                          height="511"
                          viewBox="0 0 714 511"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M366.546 -116.07C515.247 -199.787 634.301 -381.343 787.72 -359.212C947.601 -336.149 1008.28 -170.368 990.292 -26.0927C975.387 93.4467 813.574 165.99 709.977 264.303C617.106 352.436 558.082 479.863 430.952 504.713C292.438 531.788 176.201 466.116 99.7323 383.587C22.0616 299.759 -34.5148 184.519 27.1962 68.9535C84.3854 -38.1438 248.499 -49.6111 366.546 -116.07Z"
                            fill="url(#paint0_linear_1_5625)"
                            fillOpacity="0.15"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_1_5625"
                              x1="385.17"
                              y1="-203.345"
                              x2="670.971"
                              y2="398.215"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#F9E7E0" />
                              <stop
                                offset="1"
                                stopColor="white"
                                stopOpacity="0"
                              />
                            </linearGradient>
                          </defs>
                        </svg>
                      </div>
                    </div>
                  </Squircle>
                  <div
                    className={classes?.ladnding_page_mobile_image}
                    style={{
                      position: "absolute",
                      top: -30,
                      zIndex: 999,
                      pointerEvents: "none",
                    }}
                  >
                    <img
                      className={classes.landing_banner_mobile} // add media query
                     alt="landing-page"
                      src={
                        landing_imobile_image
                        // "https://static.vecteezy.com/system/resources/thumbnails/027/294/958/small_2x/couple-of-smartphone-14-pro-mockup-screen-on-the-transparent-background-with-shadow-for-your-mobile-ui-ux-png.png"
                      }
                    />
                  </div>
                </div>

                <div style={{ marginTop: 60 }}>
                  <Grid container spacing={2}>
                    <Grid xs={12} item>
                      <h3
                        style={{
                          textAlign: "center",
                          color: "#2D26E6",
                          fontFamily: "montserrat-Bold",
                          fontSize: "48px",
                        }}
                      >
                        Pourquoi choisir Frank ?
                      </h3>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={3}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "50px",
                      rowGap: 30,
                    }}
                    className="pour-qui"
                  >
                    <Grid xs={12} sm={6} md={4} item>
                      <div
                        style={{
                          position: "relative",
                        }}
                      >
                        <Squircle
                          cornerRadius={24}
                          cornerSmoothing={0.6}
                          preserveSmoothing
                          style={{
                            background: "#F4F3F6",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            height: "272px",
                            position: "relative",
                            borderRadius: "24px",
                          }}
                        >
                          <div
                            style={{
                              fontFamily: "montserrat-SemiBold",
                              fontSize: "36px",
                              color: "#2D26E6",
                              textAlign: "center",
                              paddingTop: 75,
                            }}
                            // className="display-flex"
                          >
                            <span
                              style={{
                                color: "#3026f1",
                                textAlign: "center",
                              }}
                            >
                              Livraison
                            </span>
                            <br />
                            écologique
                            <p
                              style={{
                                fontFamily: "montserrat-SemiBold",
                                fontSize: "18px",
                                color: "#000",
                                padding: "0px 30px 0px 30px",
                              }}
                            >
                              Chaque colis livré par Frank,
                              <br />
                              c'est 25kg de CO2 en moins.
                            </p>
                          </div>
                        </Squircle>

                        <img
                          src={iconOne}
                          style={{
                            position: "absolute",
                            bottom: "38%",
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            left: 0,
                            height: "100%",
                          }}
                          alt="icon-one"
                        />
                      </div>
                    </Grid>

                    <Grid xs={12} sm={6} md={4} item>
                      <div style={{ position: "relative" }}>
                        <Squircle
                          cornerRadius={24}
                          cornerSmoothing={0.6}
                          preserveSmoothing
                          style={{
                            background: "#F4F3F6",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            height: "272px",
                            position: "relative",
                            borderRadius: "24px",
                          }}
                        >
                          <div
                            style={{
                              fontFamily: "montserrat-SemiBold",
                              fontSize: "36px",
                              color: "#3026f1",
                              textAlign: "center",
                              paddingTop: 75,
                            }}
                          >
                            <span style={{ textAlign: "center" }}>
                              Livraison
                            </span>
                            <br />
                            économique
                            <p
                              style={{
                                fontFamily: "montserrat-SemiBold",
                                fontSize: "18px",
                                color: "#000",
                                padding: "0px 30px 0px 30px",
                              }}
                            >
                              Avec Frank, envoyez vos colis <br /> sans vous
                              ruiner !{" "}
                            </p>
                          </div>
                        </Squircle>
                        <img
                          src={iconTwo}
                          style={{
                            position: "absolute",
                            bottom: "38%",
                            right: 0,
                            height: "90%",
                          }}
                          alt="icon-two"
                        />
                      </div>
                    </Grid>

                    <Grid xs={12} sm={6} md={4} item>
                      <div style={{ position: "relative" }}>
                        <Squircle
                          cornerRadius={24}
                          cornerSmoothing={0.6}
                          preserveSmoothing
                          style={{
                            background: "#F4F3F6",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            height: "272px",
                            position: "relative",
                            borderRadius: "24px",
                          }}
                        >
                          <div
                            style={{
                              fontFamily: "montserrat-SemiBold",
                              fontSize: "36px",
                              color: "#3026f1",
                              textAlign: "center",
                              paddingTop: "75px",
                            }}
                          >
                            <span
                              style={{
                                color: "#3026f1",
                                textAlign: "center",
                              }}
                            >
                              Livraison
                            </span>
                            <br />
                            assurée
                            <p
                              style={{
                                fontFamily: "montserrat-SemiBold",
                                fontSize: "18px",
                                color: "#000",
                                padding: "0px 30px 0px 30px",
                              }}
                            >
                              Tous vos colis sont assurés <br /> lors de vos
                              envois !
                            </p>
                          </div>
                        </Squircle>

                        <img
                          src={iconThree}
                          style={{
                            position: "absolute",
                            bottom: "15%",
                            right: "-1%",
                            height: "334px",
                            width: "207px",
                            objectFit: "contain",
                            zIndex: 1111,
                          }}
                          alt="icon-three"
                        />
                      </div>
                    </Grid>

                    <Grid xs={12} item>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "flex-start",
                        }}
                      >
                        <CustomButton
                          onClick={() => {
                            navigate("/about-us");
                          }}
                          style={{
                            fontFamily: `montserrat-Bold !important`,
                          }}
                          classesNames={"contained_button_two"}
                          value={" Nous découvrir"}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </div>
                {/* announcements */}
                <div style={{ marginTop: 30 }}>
                  <Grid container spacing={4}>
                    <Grid xs={12} item style={{ marginBottom: "10px" }}>
                      <h3
                        style={{
                          textAlign: "center",
                          color: "#000",
                          fontFamily: "montserrat-Bold",
                          fontSize: "48px",
                          marginBottom: 10,
                        }}
                      >
                        Les dernières annonces mises en ligne{" "}
                      </h3>
                      <p
                        style={{
                          fontFamily: "montserrat-Regular",
                          fontSize: 20,
                          color: "#4B4A61",
                          textAlign: "center",
                          margin: 0,
                        }}
                      >
                        Transportez les colis de vos voisins !
                      </p>
                    </Grid>

                    {state?.annoucesData?.length > 0 ? (
                      state?.annoucesData?.slice(0, 4)?.map((i: any) => {
                        return (
                          <Grid xs={12} md={6} lg={6} xl={6} sm={6} item 
                                                        onClick={() => navigate("/transporter-un-colis")}

                          >
                           <AnnoucementCard i={i}/>
                          </Grid>
                        );
                      })
                    ) : (
                      <div
                        className="frame-2f"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          fontFamily: "montserrat-Regular",
                          fontSize: "32px",
                          fontWeight: "900",
                          color: "grey",
                          height: "400px",
                        }}
                      >
                        Aucune annonce disponible
                      </div>
                    )}

                    <Grid
                      xs={12}
                      item
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "22px",
                      }}
                    >
                      <CustomButton
                        style={{}}
                        onClick={() => {
                          navigate("/transporter-un-colis");
                        }}
                        classesNames={"contained_button_two"}
                        value={"Voir toutes les annonces"}
                      />
                    </Grid>
                  </Grid>
                </div>

                {/* marche */}
                <div style={{ marginTop: 100 }}>
                  <Grid container spacing={2}>
                    <Grid xs={12} item>
                      <h3
                        style={{
                          textAlign: "center",
                          color: "#000",
                          fontFamily: "montserrat-Bold",
                          fontSize: "48px",
                          marginBottom: 10,
                        }}
                      >
                        La livraison de particulier à particulier comment ça
                        marche ?
                      </h3>
                    </Grid>
                  </Grid>
                </div>
              </div>

              <div>
                <Grid
                  container
                  spacing={0}
                  style={{
                    background: defaultLabelColors.main_background_new,
                    padding: "0px 20px",
                    minHeight: 400,
                  }}
                >
                  <Grid xs={12} md={6} item>
                    <img
                      src={StepScreen1}
                      alt="step-one"
                      style={{
                        height: "440px",
                        width: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </Grid>
                  <Grid
                    xs={12}
                    md={6}
                    item
                    style={{ placeContent: "center", marginLeft: -50 }}
                  >
                    <p
                      style={{
                        fontFamily: "montserrat-Bold",
                        color: defaultLabelColors.main_blue,
                        fontSize: 38,
                        margin: 0,
                      }}
                    >
                      Vous voulez envoyez un colis ?
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontFamily: "montserrat-Medium",
                        fontSize: 16,
                      }}
                    >
                      Publiez votre annonce en indiquant les détails concernant
                      le
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontFamily: "montserrat-Medium",
                        fontSize: 16,
                      }}
                    >
                      colis et sa destination.
                    </p>
                    <span style={{ marginTop: "20px", fontWeight: "700" }}>
                      <CustomButton
                        style={{
                          background: "transparent",
                          border: "1.14px solid #BCBBC4",
                          borderRadius: "13.69px",
                          color: "#080626",
                          marginTop: "20px",
                          padding: "13.67px 27.37px",
                          fontFamily: "montserrat-Bold",
                          fontSize: "16px",
                        }}
                        onClick={() => {
                          navigate("/send-package");
                        }}
                        value={"Envoyer un colis"}
                      />
                    </span>
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={0}
                  style={{
                    background: defaultLabelColors.main_blue,
                    padding: "0px 100px",
                    minHeight: 400,
                  }}
                >
                  <Grid
                    xs={12}
                    md={6}
                    item
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "flex-start",
                      flexDirection: "column",
                      textAlign: "left",
                      paddingLeft: 100,
                    }}
                  >
                    <p
                      style={{
                        fontFamily: "montserrat-Bold",
                        color: defaultLabelColors.white,
                        fontSize: 38,
                        margin: 0,
                      }}
                    >
                      Vous vous voyez
                    </p>
                    <p
                      style={{
                        fontFamily: "montserrat-Bold",
                        color: defaultLabelColors.white,
                        fontSize: 38,
                        margin: 0,
                      }}
                    >
                      plutôt transpoteur ?
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontFamily: "montserrat-Medium",
                        fontSize: 16,
                        textAlign: "left",
                        color: "#fff",
                        marginTop: 10,
                      }}
                    >
                      Parcourez les offres de livraisons disponibles
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontFamily: "montserrat-Medium",
                        fontSize: 16,
                        color: "#fff",
                      }}
                    >
                      et choisissez celle qui vous convient.{" "}
                    </p>
                    <span style={{ fontWeight: "700" }}>
                      <CustomButton
                        style={{
                          background: "transparent",
                          border: "1.12px solid #BCBBC4",
                          borderRadius: "13.41px",
                          color: "#fff",
                          marginTop: "20px",
                          padding: "13.41px 26.82px",
                          fontFamily: "montserrat-Bold",
                          fontSize: "16px",
                        }}
                        onClick={() => {
                          navigate("/transporter-un-colis");
                        }}
                        value={"Voir les annonces"}
                      />
                    </span>
                  </Grid>
                  <Grid xs={12} md={6} item style={{ position: "relative" }}>
                    <img
                      src={StepScreen2}
                      alt="step-one"
                      style={{
                        top: -100,
                        height: "500px",
                        width: "100%",
                        objectFit: "cover",
                        zIndex: 111,
                        position: "absolute",
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={0}
                  style={{
                    background: defaultLabelColors.main_background_new,
                    paddingLeft: 50,
                  }}
                >
                  <Grid
                    xs={12}
                    md={6}
                    item
                    style={{ position: "relative", minHeight: 450 }}
                  >
                    <img
                      src={StepScreen3}
                      alt="step-one"
                      style={{
                        height: "650px",
                        // width: "100%",
                        objectFit: "cover",
                        position: "absolute",
                        zIndex: 111,
                        top: -120,
                        maxWidth: 983,
                        pointerEvents: "none",
                      }}
                    />
                  </Grid>
                  <Grid
                    xs={12}
                    md={6}
                    item
                    style={{ placeContent: "center", marginLeft: "-50px" }}
                  >
                    <p
                      style={{
                        fontFamily: "montserrat-Bold",
                        color: defaultLabelColors.main_blue,
                        fontSize: 38,
                        margin: 0,
                      }}
                    >
                      Le colis a été livré !
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontFamily: "montserrat-Medium",
                        fontSize: 16,
                      }}
                    >
                      Félicitations ! Votre porte-monnaie se remplit
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontFamily: "montserrat-Medium",
                        fontSize: 16,
                      }}
                    >
                      automatiquement une fois que la livraison a été assurée.
                    </p>
                    <span
                      style={{
                        marginTop: "20px",
                        fontWeight: "700",
                        fontFamily: "montserrat-Bold",
                      }}
                    >
                      <CustomButton
                        style={{
                          background: "transparent",
                          border: "1.17px solid #BCBBC4",
                          borderRadius: "14px",
                          color: defaultLabelColors.main_font,
                          marginTop: "20px",
                          padding: "14px 28px",
                          fontFamily: "montserrat-Bold",
                          fontSize: "16px",
                        }}
                        onClick={() => {
                          navigate("/wallet");
                        }}
                        value={"Gagner de l’argent"}
                      />
                    </span>
                  </Grid>
                </Grid>
              </div>

              <div
                style={{
                  padding: "0px 140px 0px 140px",
                  background: "#FFF8F5",
                }}
              >
                <div style={{ position: "relative" }}>
                  <Squircle
                    cornerRadius={32}
                    preserveSmoothing
                    cornerSmoothing={0.6}
                    style={{
                      background: "#fff",
                      padding: 32,
                      height: "100%",
                      marginTop: 100,
                      maxHeight: "340px",
                      minHeight: "280px",
                      position: "relative",
                    }}
                  >
                    <Grid container spacing={spacing.spacing2}>
                      <Grid xs={12} md={6} sm={4} item>
                        <h3
                          style={{
                            fontFamily: "montserrat-Bold",
                            fontWeight: 700,
                            fontSize: 28,
                            color: "#080626",
                          }}
                        >
                          Vous êtes un professionnel ?
                        </h3>

                        <p
                          style={{
                            fontFamily: "montserrat-SemiBold",
                            color: "#000",
                            fontSize: 20,
                          }}
                        >
                          Découvrez notre solution de livraison Peoples Post !
                        </p>

                        <p
                          style={{
                            fontFamily: "montserrat-Regular",
                            fontSize: "14px",
                            color: "#000",
                          }}
                        >
                          Éco-responsable, économique et flexible, la solution
                          Peoples Post change la vie des professionnels.
                          <br />
                          En fonction de vos besoins, nous prenons en charge la
                          collecte, la préparation de commande et même la
                          livraison au client final.
                        </p>
                        <p
                          style={{
                            fontFamily: "montserrat-Regular",
                            fontSize: "14px",
                            color: "#000",
                          }}
                        >
                          Pour plus de fluidité, Peoples Post peut s'intégrer à
                          vos systèmes <br /> de gestion via Sendcloud !
                        </p>
                      </Grid>
                    </Grid>
                  </Squircle>
                  <div
                    style={{
                      position: "absolute",
                      right: -140,
                      height: 600,
                      top: -100,
                      objectFit: "contain",
                    }}
                  >
                    <img
                      src={pPostImage}
                      alt=""
                      style={{ height: "100%", objectFit: "contain" }}
                    />
                  </div>
                </div>

                <div style={{ paddingTop: 60 }}>
                  <Grid
                    container
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <h2
                        style={{
                          textAlign: "left",
                          fontSize: "28px",
                          padding: "40px 0px 20px 0px",
                          margin: 0,
                          color: "#000",
                        }}
                        className="montserrat-Bold"
                      >
                        Nos Actualités
                      </h2>
                      <ul className="cards">
                        <Grid container spacing={4}>
                          {state?.allBlogs?.slice(0, 3)?.map((item: any) => {
                            return (
                              <>
                                <Grid
                                  item
                                  xs={12}
                                  md={4}
                                  // className="cards__item"
                                  style={{
                                    display: "flex",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    navigate(
                                      `/blog-details/${item?.blog_cat_id}/${item?.id}`
                                    );
                                  }}
                                >
                                  <div className="card">
                                    <CardMedia
                                      component="img"
                                      style={{
                                        minHeight: 296,
                                        objectFit: "cover",
                                        borderRadius: 8,
                                      }}
                                      image={
                                        item?.blog_image?.[1] ??
                                        item?.blog_image?.[0]
                                      } // Replace with the image URL you need
                                      alt="Blog card image"
                                    />
                                    <div
                                      className="card__content"
                                      style={{ gap: 10 }}
                                    >
                                      <div style={{ display: "flex" }}>
                                        <div
                                          className="card__title"
                                          style={{ flex: 1 }}
                                        >
                                          {handleLocalize(item?.title)}
                                        </div>
                                      </div>
                                      <p
                                        className="card__text"
                                        style={{ margin: 0, maxLines: 4 }}
                                      >
                                        {handleLocalize(item?.sub_title)}
                                      </p>
                                      <p
                                        style={{
                                          fontSize: "16px",
                                          color: "#78778A",
                                          fontWeight: "400",
                                          margin: 0,
                                        }}
                                        className="montserrat-Regular"
                                      >
                                        {moment(
                                          `${item?.created_at}`.endsWith("Z")
                                            ? item?.created_at
                                            : item?.created_at + "Z"
                                        ).format("DD MMMM YYYY")}{" "}
                                        <span
                                          style={{
                                            fontFamily: "montserrat-SemiBold",
                                            textDecoration: "underline",
                                            color: "#000",
                                            paddingLeft: 5,
                                          }}
                                        >
                                          {handleLocalize(item?.category_name)}
                                        </span>
                                      </p>
                                      <div>
                                        <CustomButton
                                          style={{
                                            padding: "9px 21px",
                                          }}
                                          onClick={() => {
                                            navigate("/transporter-un-colis");
                                          }}
                                          classesNames={"new_contained_button"}
                                          value={"En savoir plus"}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </Grid>
                              </>
                            );
                          })}
                        </Grid>
                      </ul>
                    </div>
                  </Grid>
                </div>

                <div className="display-flex">
                  <Grid
                    container
                    spacing={2}
                    marginTop={5}
                    style={{
                      // padding: 10,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Grid
                      xs={12}
                      item
                      className="display-flex"
                      style={{
                        flexDirection: "column",
                        // padding: "10px",
                        borderRadius: "18px",
                      }}
                    >
                      <h3
                        style={{
                          fontSize: "28px",
                          fontFamily: "montserrat-Bold",
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                          textAlign: "left",
                          width: "100%",
                          padding: "15px",
                          // paddingLeft: "32px",
                          margin: 0,
                          color: defaultLabelColors.main_font_brown,
                        }}
                      >
                        FAQ
                      </h3>
                      <Grid
                        xs={12}
                        item
                        className="display-flex"
                        style={{
                          flexDirection: "column",
                          // padding: "10px",
                          borderRadius: "18px",
                          gap: 20,
                        }}
                      >
                        <Accordion
                          elevation={0}
                          style={{
                            border: "0px",
                            background: defaultLabelColors?.main_background_new,
                          }}
                          expanded={state?.expanded_1}
                          onChange={() => handleExpanded("expanded_1")}
                        >
                          <AccordionSummary
                            style={{ border: "none", marginTop: 20 }}
                            // expandIcon={<AddIcon />}
                            expandIcon={
                              state?.expanded_1 ? (
                                <RemoveIcon
                                  style={{
                                    color: defaultLabelColors?.main_orange_new,
                                  }}
                                />
                              ) : (
                                <AddIcon />
                              )
                            } // Dynamic icon change
                            className="faq-comments"
                            sx={{
                              "&.Mui-expanded h3": {
                                color: defaultLabelColors?.main_orange_new,
                              }, // Change h3 color when expanded
                            }}
                          >
                            <h3
                              style={{
                                fontWeight: "500",
                                fontFamily: "montserrat-Medium",
                                fontSize: 22,
                              }}
                            >
                              Comment fonctionne la livraison collaborative ?{" "}
                            </h3>
                          </AccordionSummary>
                          <AccordionDetails
                            style={{
                              width: "90%",
                              fontFamily: "montserrat-Regular",
                              color: "#4B4A61",
                              fontSize: 18,
                            }}
                          >
                            Grâce à notre plateforme, un particulier peut
                            envoyer un colis qui sera livré par un autre
                            particulier lors d’un de ses trajets personnels. Au
                            cœur de notre activité, la livraison collaborative
                            nous permet de créer une communauté d’entraide en
                            garantissant un service d’envoi peu coûteux et
                            écologique.
                          </AccordionDetails>
                        </Accordion>

                        <Accordion
                          elevation={0}
                          style={{
                            border: "0px",
                            background: defaultLabelColors?.main_background_new,
                          }}
                          expanded={state?.expanded_2}
                          onChange={() => handleExpanded("expanded_2")}
                        >
                          <AccordionSummary
                            style={{ border: "none", marginTop: 20 }}
                            // expandIcon={<AddIcon />}
                            expandIcon={
                              state?.expanded_2 ? (
                                <RemoveIcon
                                  style={{
                                    color: defaultLabelColors?.main_orange_new,
                                  }}
                                />
                              ) : (
                                <AddIcon />
                              )
                            } // Dynamic icon change
                            className="faq-comments"
                            sx={{
                              "&.Mui-expanded h3": {
                                color: defaultLabelColors?.main_orange_new,
                              }, // Change h3 color when expanded
                            }}
                          >
                            <h3
                              style={{
                                fontWeight: "500",
                                fontFamily: "montserrat-Medium",
                                fontSize: 22,
                                padding: "20px 0px",
                              }}
                            >
                              Comment fonctionne la livraison professionnelle
                              avec Frank ?{" "}
                            </h3>
                          </AccordionSummary>
                          <AccordionDetails
                            style={{
                              width: "90%",
                              fontFamily: "montserrat-Regular",
                              color: "#4B4A61",
                              fontSize: 18,
                            }}
                          >
                            <p>
                              {" "}
                              Nous couvrons l’envoi du premier au dernier
                              kilomètre et stockons vos colis dans notre
                              entrepôt en Île-de-France. En fonction de vos
                              besoins, nous proposons plusieurs modes de
                              livraison professionnelle :
                            </p>

                            <p>
                              {" "}
                              • Pick & Pack : récupération des colis à votre
                              adresse, préparation des colis, packaging d’envoi{" "}
                            </p>
                            <p>
                              {" "}
                              • Livraison totale : nous nous occupons de tout,
                              de la récupération des colis jusqu’à leur dépôt
                              chez le client final{" "}
                            </p>
                            <p>
                              {" "}
                              • Stockage : nous stockons vos colis dans notre
                              entrepôt en Île-de-France, avant leur retrait
                            </p>

                            <p>
                              Pour plus d’informations, vous pouvez nous
                              contacter en envoyant un mail à l’adresse :
                              hello@frankme.com
                            </p>
                          </AccordionDetails>
                        </Accordion>
                        <Accordion
                          elevation={0}
                          style={{
                            border: "0px",
                            background: defaultLabelColors?.main_background_new,
                          }}
                          expanded={state?.expanded_3}
                          onChange={() => handleExpanded("expanded_3")}
                        >
                          <AccordionSummary
                            style={{ border: "none", marginTop: 20 }}
                            expandIcon={
                              state?.expanded_3 ? (
                                <RemoveIcon
                                  style={{
                                    color: defaultLabelColors?.main_orange_new,
                                  }}
                                />
                              ) : (
                                <AddIcon />
                              )
                            }
                            className="faq-comments"
                            sx={{
                              "&.Mui-expanded h3": {
                                color: defaultLabelColors?.main_orange_new,
                              },
                            }}
                          >
                            <h3
                              style={{
                                fontWeight: "500",
                                fontFamily: "montserrat-Medium",
                                fontSize: 22,
                                padding: "20px 0px",
                              }}
                            >
                              Puis-je gagner de l’argent avec Frank ?
                            </h3>
                          </AccordionSummary>
                          <AccordionDetails
                            style={{
                              width: "90%",
                              fontFamily: "montserrat-Regular",
                              color: "#4B4A61",
                              fontSize: 18,
                            }}
                          >
                            <p>
                              Vous êtes transporteur ? En voiture, en train, en
                              trottinette, en péniche ou à pied, quel que soit
                              le mode de transport, vous gagnez de l’argent
                              !ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ
                              ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ
                              <br></br>
                              Vous envoyez un colis avec Frank ? Vous ne gagnez
                              pas d’argent, mais vous en économisez à coup sûr !
                            </p>
                          </AccordionDetails>
                        </Accordion>

                        <Accordion
                          elevation={0}
                          style={{
                            border: "0px",
                            background: defaultLabelColors?.main_background_new,
                          }}
                          expanded={state?.expanded_4}
                          onChange={() => handleExpanded("expanded_4")}
                        >
                          <AccordionSummary
                            style={{ border: "none", marginTop: 20 }}
                            // expandIcon={<AddIcon />}
                            expandIcon={
                              state?.expanded_4 ? (
                                <RemoveIcon
                                  style={{
                                    color: defaultLabelColors?.main_orange_new,
                                  }}
                                />
                              ) : (
                                <AddIcon />
                              )
                            } // Dynamic icon change
                            className="faq-comments"
                            sx={{
                              "&.Mui-expanded h3": {
                                color: defaultLabelColors?.main_orange_new,
                              }, // Change h3 color when expanded
                            }}
                          >
                            <h3
                              style={{
                                fontWeight: "500",
                                fontFamily: "montserrat-Medium",
                                fontSize: 22,
                                padding: "20px 0px",
                              }}
                            >
                              Comment fonctionne l’assurance des colis ?{" "}
                            </h3>
                          </AccordionSummary>
                          <AccordionDetails
                            style={{
                              width: "90%",
                              fontFamily: "montserrat-Regular",
                              color: "#4B4A61",
                              fontSize: 18,
                            }}
                          >
                            Tout envoi de colis via Frank est assuré à une
                            hauteur de 100 €. Pour vos colis les plus précieux,
                            vous pouvez souscrire à une assurance supplémentaire
                            (HISCOX).ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ
                          </AccordionDetails>
                        </Accordion>
                        <Accordion
                          elevation={0}
                          style={{
                            border: "0px",
                            background: defaultLabelColors?.main_background_new,
                            width: "100%",
                          }}
                          expanded={state?.expanded_5}
                          onChange={() => handleExpanded("expanded_5")}
                        >
                          <AccordionSummary
                            style={{ border: "none", marginTop: 20 }}
                            // expandIcon={<AddIcon />}
                            expandIcon={
                              state?.expanded_5 ? (
                                <RemoveIcon
                                  style={{
                                    color: defaultLabelColors?.main_orange_new,
                                  }}
                                />
                              ) : (
                                <AddIcon />
                              )
                            } // Dynamic icon change
                            className="faq-comments"
                            sx={{
                              "&.Mui-expanded h3": {
                                color: defaultLabelColors?.main_orange_new,
                              }, // Change h3 color when expanded
                            }}
                          >
                            <h3
                              style={{
                                fontWeight: "500",
                                fontFamily: "montserrat-Medium",
                                fontSize: 22,
                                padding: "20px 0px",
                              }}
                            >
                              Comment devenir transporteur ?
                            </h3>
                          </AccordionSummary>
                          <AccordionDetails
                            style={{
                              width: "100%",
                              fontFamily: "montserrat-Regular",
                              color: "#4B4A61",
                              fontSize: 18,
                            }}
                          >
                            <p>
                              {" "}
                              Pour devenir transporteur à nos côtés, rien de
                              plus simple :
                              ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ
                              ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ
                            </p>

                            <p>
                              {" "}
                              • Vous créez un compte sur le site ou
                              l’application de Frank ;{" "}
                            </p>
                            <p>
                              {" "}
                              • Vous checkez les annonces à côté de vous, ou sur
                              vos trajets ;{" "}
                            </p>
                            <p> • Vous acceptez une offre ;</p>
                            <p>
                              {" "}
                              • Vous remettez le colis au destinataire, qui vous
                              remet un code pour valider la livraison ;{" "}
                            </p>
                            <p>
                              {" "}
                              • Vous recevez le montant de la livraison sur
                              votre porte-monnaie une fois que vous avez
                              renseigné le code.{" "}
                            </p>
                          </AccordionDetails>
                        </Accordion>

                        <Accordion
                          elevation={0}
                          style={{
                            border: "0px",
                            background: defaultLabelColors?.main_background_new,
                          }}
                          expanded={state?.expanded_6}
                          onChange={() => handleExpanded("expanded_6")}
                        >
                          <AccordionSummary
                            style={{ border: "none", marginTop: 20 }}
                            // expandIcon={<AddIcon />}
                            expandIcon={
                              state?.expanded_6 ? (
                                <RemoveIcon
                                  style={{
                                    color: defaultLabelColors?.main_orange_new,
                                  }}
                                />
                              ) : (
                                <AddIcon />
                              )
                            } // Dynamic icon change
                            className="faq-comments"
                            sx={{
                              "&.Mui-expanded h3": {
                                color: defaultLabelColors?.main_orange_new,
                              }, // Change h3 color when expanded
                            }}
                          >
                            <h3
                              style={{
                                fontWeight: "500",
                                fontFamily: "montserrat-Medium",
                                fontSize: 22,
                                padding: "20px 0px",
                                paddingRight: "15px",
                              }}
                            >
                              En tant que transporteur, comment transférer
                              l’argent de mon porte-monnaie sur mon compte
                              bancaire ?{" "}
                            </h3>
                          </AccordionSummary>
                          <AccordionDetails
                            style={{
                              width: "90%",
                              fontFamily: "montserrat-Regular",
                              color: "#4B4A61",
                              fontSize: 18,
                            }}
                          >
                            Sur l’application Frank, il y a un espace
                            porte-monnaie, où vous trouverez le montant total de
                            vos gains. Il suffit de cliquer sur la carte
                            bancaire, puis sur “transférer sur un compte
                            bancaire” et de renseigner les informations
                            demandées. L’argent arrive sur votre compte au bout
                            de quelques jours !
                          </AccordionDetails>
                        </Accordion>

                        <Accordion
                          elevation={0}
                          style={{
                            border: "0px",
                            background: defaultLabelColors?.main_background_new,
                          }}
                          expanded={state?.expanded_7}
                          onChange={() => handleExpanded("expanded_7")}
                        >
                          <AccordionSummary
                            style={{ border: "none", marginTop: 20 }}
                            // expandIcon={<AddIcon />}
                            expandIcon={
                              state?.expanded_7 ? (
                                <RemoveIcon
                                  style={{
                                    color: defaultLabelColors?.main_orange_new,
                                  }}
                                />
                              ) : (
                                <AddIcon />
                              )
                            } // Dynamic icon change
                            className="faq-comments"
                            sx={{
                              "&.Mui-expanded h3": {
                                color: defaultLabelColors?.main_orange_new,
                              }, // Change h3 color when expanded
                            }}
                          >
                            <h3
                              style={{
                                fontWeight: "500",
                                fontFamily: "montserrat-Medium",
                                fontSize: 22,
                                padding: "20px 0px",
                              }}
                            >
                              Y a-t-il une limite de poids pour la livraison des
                              colis ?{" "}
                            </h3>
                          </AccordionSummary>
                          <AccordionDetails
                            style={{
                              width: "90%",
                              fontFamily: "montserrat-Regular",
                              color: "#4B4A61",
                              fontSize: 18,
                            }}
                          >
                            Il n’y a pas de limite de poids chez Frank. Pour un
                            déménagement, vous pouvez prévoir le nombre de
                            personnes dont vous avez besoin en renfort en
                            fonction de la taille des meubles.
                          </AccordionDetails>
                        </Accordion>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      <div className="tab-screen" style={{ background: "#FFF8F5" }}>
        <TabletView
          {...state}
          {...props}
          handleGetRecentJobs={handleGetRecentJobs}
          handleGetAllBlog={handleGetAllBlog}
        />
      </div>

      <div className="mobile-screen">
        <MobileResponsive />
      </div>
      <div style={{ background: "#FFF8F5" }}>
        {screen_1024 ? (
          <div
            className="main-container"
            style={{ background: defaultLabelColors.main_background }}
          >
            <CustomFooter />
          </div>
        ) : screen_600 ? (
          <CustomMobileFooter />
        ) : null}
      </div>
    </>
  );
}

export default LandingPage;

// export const BlogCard = ({ i }: any) => (
//   <div className="blogcard-container">
//     <div className="blogcard-image">
//       <img
//         src={i?.blog_image?.[0]}
//         alt="Box-Image"
//         className="blogresponsive-image"
//       />
//     </div>
//     <div className="blogcard-content">
//       <h3 className="blogcard-title">
//         <strong>{handleLocalize(i?.title)}</strong>
//       </h3>
//       <p className="blogcard-subtitle">il y a 10 heures</p>
//       <p className="blogcard-description">{handleLocalize(i?.sub_title)}</p>
//       <div className="blogcard-arrow">
//         <span>&#10140;</span>
//       </div>
//     </div>
//   </div>
// )
